/**
 Validates org numbers from Cyprus
 */
export const validateCyprusOrgNumber = (number: string) => {
  // TODO: this implementation is not the same as in the excel sheet, since apparently whitespace is not prohibited, it's required
  const cyprusOrgNumberRegex = /^[A-Z]{2}\s\d{1,8}$/g;

  return cyprusOrgNumberRegex.test(number);
};
